import { ErrorMessage, Field, Form, Formik } from "formik";
import { object, string, number } from 'yup';
import { useSelector } from "react-redux";
import SubmitButton from "../c&m/facturacion/SubmitButton";
import Axios from "axios";
import Cookies from "universal-cookie";
import { Tab } from "@headlessui/react";

const cargos = [
    {
        "IdProducto": 190,
        "Descripcion": "PARQUEO SABADO INFORMACION",
        "Descripcion_Corta": "PARQUEO SABADO INFORMACION",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 0,
        "Precio": 15
    },
    {
        "IdProducto": 191,
        "Descripcion": "PARQUEO SABADO MOTOS",
        "Descripcion_Corta": "PARQUEO SABADO MOTOS",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 0,
        "Precio": 10
    },
    {
        "IdProducto": 192,
        "Descripcion": "PARQUEO SABADO VEHICULOS",
        "Descripcion_Corta": "PARQUEO SABADO VEHICULOS",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 0,
        "Precio": 20
    },
    {
        "IdProducto": 193,
        "Descripcion": "PARQUEO UNIVERSIDAD QR",
        "Descripcion_Corta": "PARQUEO UNIVERSIDAD QR",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 0,
        "Precio": 325
    },
    {
        "IdProducto": 194,
        "Descripcion": "PARQUEO VIERNES",
        "Descripcion_Corta": "PARQUEO VIERNES",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 0,
        "Precio": 10
    },
    {
        "IdProducto": 251,
        "Descripcion": "TICKETS DE PARQUEO PARA L-V",
        "Descripcion_Corta": "TICKETS DE PARQUEO PARA L-V",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 2.5,
        "Precio": 5
    },
    {
        "IdProducto": 252,
        "Descripcion": "TICKETS DE PARQUEO PARA SÁBADOS",
        "Descripcion_Corta": "TICKETS DE PARQUEO PARA SÁBADOS",
        "Imagen": "",
        "IdTipo": 3,
        "Tipo": "SERVICIOS",
        "IdCategoria": 5,
        "Categoria": "PARQUEO",
        "Costo": 5,
        "Precio": 10
    }
]

const FacturasSM = ({ setLoading, setModal, options }) => {

    const { IdEmp } = useSelector(state => state.auth);
    const cookies = new Cookies();
    //const urlInvoiceApi = cookies.get('__urlInvoiceApi');
    const urlState = useSelector(state => state.url.urlInvoiceApi)
    const urlInvoiceApi = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlInvoiceApi") : urlState

    const { headersAPI: headers } = useSelector(state => state.url)

    //Manejo de post
    const fetchData = async (data) => {
        setLoading(true);
        try {
            await Axios({
                method: 'POST',
                url: urlInvoiceApi + '/inventario/facturas_parqueo',
                headers,
                data
            });

            setLoading(false);

            setModal({
                msg: '¡Facturas realizadas con exito!',
                ok: true,
                show: true,
                reload: true
            });

        } catch (err) {
            setModal({
                ok: false,
                msg: 'Por favor intentelo de nuevo.',
                show: true,
                reload: true
            })

            console.log(err);

        };
    }

    const handlePost = (values) => {
        const data = JSON.stringify({
            Nit: 'CF',
            NombreDoc: '',
            Direccion: 'Ciudad',
            Canal: 4,
            CantFacturas: values.Cantidad,
            IdProducto: values.Cargo,
            IdEmp,
            HostName: 'DEV07',    
            IpHost: '131.107.1.235',    
            OS: 'Windows',
            Sabado: values.Fecha === 'Sábado' ? 1 : 0,
        });

        fetchData(data);
    }

    //Handler para rellenar campo Valor
    const handleCargo = (e, setFieldValue) => {
        setFieldValue('Cargo', e.target.value);

        const valor = ((id) => {

            if (id.length === 0) {
                return '';
            }

            const [ cargo ] = cargos.filter(c => c.IdProducto === Number(id));
            return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(cargo.Precio);

        })(e.target.value);

        setFieldValue('Valor', valor)

    }

    return(
        <Formik
            initialValues={{
                Fecha: '',
                Cargo: '',
                Valor: '',
                Cantidad: 0,
            }}
            validationSchema={object({
                Fecha: string().required('Dato obligatorio'),
                Cargo: string().required('Dato obligatorio'),
                Cantidad: number().min(1, 'Mínimo 1').max(100, 'Máximo 100'),
            })}
            onSubmit={handlePost}
        >
            { ({setFieldValue}) => {

                    return(
                        <Form>
                            <Tab.Panel className="bg-primarioMira p-5 rounded-lg shadow-2xl flex flex-col gap-5 w-full max-w-[64rem] mx-auto">
                                <div className="lg:grid lg:grid-cols-3 lg:gap-5">
                                    <div className="lg:col-span-1 lg:ml-11 lg:mt-5">
                                        <h3 className="text-lg font-medium leading-6 text-white">Facturas de parqueo</h3>
                                        <p className="py-2 text-sm text-grisMira">Rellene la información respectiva para imprimir Facturas.</p>
                                    </div>
                                    <div className="lg:col-span-2 lg:mr-5 mt-5">
                                        <div className="flex flex-col gap-5 lg:grid lg:grid-cols-6 lg:grid-rows-2">

                                            <div className="col-span-2 row-span-full flex flex-col gap-5 p-5 bg-secundarioMira rounded-lg shadow-lg">
                                                <ErrorMessage component="p" name="Fecha" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                <legend className="text-white font-semibold text-sm border-b border-white pb-2 ">Fecha</legend>
                                                <div className="flex justify-between gap-2">
                                                    <label className="text-sm font-medium text-grisMira">Día</label>
                                                    <Field
                                                        className='mt-1 text-azulLogos'
                                                        name='Fecha'
                                                        value='Día'
                                                        type='radio'
                                                    />
                                                </div>

                                                <div className="flex justify-between gap-2">
                                                    <label className="text-sm font-medium text-grisMira">Sábado</label>
                                                    <Field
                                                        className='mt-1 text-azulLogos'
                                                        name='Fecha'
                                                        value='Sábado'
                                                        type='radio'
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-span-4">
                                                <div className="flex justify-between">    
                                                    <label className="block text-sm font-medium text-grisMira">Cargo</label>
                                                    <ErrorMessage component="p" name="Cargo" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                </div>
                                                <Field
                                                    onChange={e => handleCargo(e, setFieldValue)}
                                                    name="Cargo"
                                                    as="select"
                                                    className="cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                >
                                                    <option value=''>----SELECCIONE UN CARGO-----</option>
                                                    {cargos.map(cargo => <option key={cargo.IdProducto} value={cargo.IdProducto}>{cargo.Descripcion}</option>)}
                                                </Field>
                                            </div>

                                            <div className="col-span-2">
                                                <label className="block text-sm font-medium text-grisMira">Valor</label>
                                                <Field
                                                    readOnly
                                                    type="text"
                                                    name="Valor"
                                                    className="cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                />
                                            </div>

                                            <div className="col-span-2">
                                                <div className="flex justify-between">
                                                    <label className="block text-sm font-medium text-grisMira">Cantidad</label>
                                                    <ErrorMessage component="p" name="Cantidad" className="w-full text-right block text-sm font-semibold text-red-500"/>
                                                </div>
                                                <Field
                                                    type="number"
                                                    name="Cantidad"
                                                    className="cursor-pointer mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <SubmitButton
                                        className="px-0"
                                        label='Generar facturas'
                                    />
                                </div>
                            </Tab.Panel>
                        </Form>
                    )
                }
            }
        </Formik>
    );
};

export default FacturasSM